import React, { useEffect, useState, useMemo } from 'react';
import { ProSidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import clientsIcon from '../icons/users.svg';
import userIcon from '../icons/user.svg';
import purchasesIcon from '../icons/corner-down-left.svg';
import catalogIcon from '../icons/book-open.svg';
import dashboardIcon from '../icons/grid.svg';
import ordersIcon from '../icons/package.svg';
import repoIcon from '../icons/layers.svg';
import zoneIcon from '../icons/zone_map.svg';
import chevronUp from '../icons/chevron-upG.svg';
import chevronDown from '../icons/chevron-downG.svg';
import logoGF from '../images/gf_inventory_logo.png';
import paymentIcon from '../icons/payment.svg';
import performanceIcon from '../icons/performance.svg';

const Sidebar = () => {
  const location = useLocation();
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const { t } = useTranslation();

  const handleImageError = (e) => {
    e.target.src = logoGF;
    e.target.style.width = "150px";
    e.target.style.height = "50px";
  };

  // Role-based access configuration
  const roleBasedModules = {
    ROLE_ADMIN: {
      menus: ['depot', 'products', 'inventaire', 'zones', 'emplacements', 'users'],
    },
    ROLE_INVENTORY_MANAGER: {
      menus: ['dashboard',  'ecartsReport', 'zonesReport'],
    },
  };

  const MENU_ITEMS = [
    {
      key: "depot",
      titleKey: "titles.inventory_depot",
      to: "/",
      icon: repoIcon,
      alt: "Dépôts",
    },
    {
      key: "products",
      titleKey: "titles.products",
      to: "/produits",
      icon: catalogIcon,
      alt: "Produits",
    },
    {
      key: "inventaire",
      titleKey: "titles.inventory",
      to: "/inventaires",
      icon: ordersIcon,
      alt: "Inventaires",
    },
    {
      key: "zones",
      titleKey: "titles.inventory_zones",
      to: "/zones",
      icon: zoneIcon,
      alt: "Zones",
    },
    {
      key: "emplacements",
      titleKey: "titles.inventory_emplacements",
      to: "/emplacements",
      icon: zoneIcon,
      alt: "Emplacements",
    },
    {
      key: "users",
      titleKey: "titles.inventory_users",
      to: "/utilisateurs",
      icon: userIcon,
      alt: "Users",
    },
    {
      key: "dashboard",
      titleKey: "titles.dashboard",
      to: "/dashboard",
      icon: dashboardIcon,
      alt: "Dashboard",
    },
    {
      key: "ecartsReport",
      titleKey: "titles.ecartsReport",
      to: "/rapport-ecarts",
      icon: dashboardIcon,
      alt: "Ecart Report",
    },
    {
      key: "zonesReport",
      titleKey: "titles.zonesReport",
      to: "/rapport-zones",
      icon: zoneIcon,
      alt: "Zones Report",
    },
    {
      key: "zonesReportDetails",
      titleKey: "titles.zonesReportDetails",
      to: "/rapport-zones/details/:id",
      icon: zoneIcon,
      alt: "Zones Report Details",
    },
  ];

  useEffect(() => {
    const roleStore = localStorage.getItem('user');
    const role = roleStore ? JSON.parse(roleStore).role : null;
    setUserRole(role);
  }, []);

  const purpleFilter =
    'brightness(0) saturate(100%) invert(36%) sepia(81%) saturate(4000%) hue-rotate(225deg) brightness(95%) contrast(90%)';
  const defaultFilter = 'none';

  // Filter menu items based on user role
  const filteredMenuItems = MENU_ITEMS.filter((menuItem) =>
    roleBasedModules[userRole]?.menus?.includes(menuItem.key)
  );

  const logo = localStorage.getItem('logo') ? localStorage.getItem('logo') : logoGF;

return (
  <ProSidebar
    className="h-screen overflow-y-auto bg-[#F8F9FC] shadow-lg"
    style={{ width: "100%", display: "flex", flexDirection: "column" }}
  >
    {/* Logo Section */}
    <div className="flex items-center justify-center h-[140px]">
      <img src={logo} alt="Company Logo" className="h-10" onError={handleImageError} />
    </div>

    <Menu>
      {filteredMenuItems.map(({ key, titleKey, to, icon, alt }) => {
        const active = to === "/" 
          ? location.pathname === to 
          : location.pathname.startsWith(to);
        return (
          <MenuItem
            key={key}
            active={active}
            onClick={() => setExpandedMenu(null)}
            className={`flex items-center px-4 py-3 ${
              active ? "bg-[rgba(107,120,248,0.15)] text-[#6A78F8]" : "text-[#231E29]"
            }`}
            style={{
              borderRadius: "8px",
              margin: "0 10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Link to={to} className="w-full h-full flex items-center">
              <span className="flex items-center gap-3">
                <img
                  src={icon}
                  alt={alt}
                  style={{ filter: active ? purpleFilter : defaultFilter }}
                />
                <span className={`${active ? "font-semibold" : "font-medium"}`}>{t(titleKey)}</span>
              </span>
            </Link>
          </MenuItem>
        );
      })}
    </Menu>
  </ProSidebar>
);

};

export default Sidebar;
